/**
 * PaperForm — shared style tokens.
 *
 * Extracted 2026-05-05 from the RfiForm.jsx redesign (commit 3c68067) per
 * the FORMS-QUALITY-AUDIT-2026-05-05 remediation plan, Phase 0. Used by
 * every form that aspires to the "True-to-Form, Apple-like" Quality
 * Standard documented in outputs/a3sfm-build/FORMS-QUALITY-AUDIT-2026-05-05.md.
 */

// Section header — uppercase tracking-wider, color text.secondary.
// Used for top-level groupings (Requested Of, Project Reference, etc.)
export const SECTION_LABEL = {
  display: "block",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "text.secondary",
  mb: 1,
};

// Field label — slightly smaller / tighter than SECTION_LABEL.
// Used for individual form fields within a section.
export const FIELD_LABEL = {
  display: "block",
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  color: "text.secondary",
  mb: 0.5,
};

// Status pill color map — semantic colors for lifecycle states.
// Keep this list synchronized with the backend state-machine values.
// Used by <StatusPill> via the AISC §1.7.0 lifecycle (DRAFT / SENT / ANSWERED /
// CLOSED / CANCELLED / RETURNED) plus a few generic states (APPROVED,
// REJECTED, IN_REVIEW) for non-AISC surfaces.
export const STATUS_COLOR = {
  DRAFT:        { bg: "#e9ecef", color: "#495057" },
  SENT:         { bg: "#cfe2ff", color: "#052c65" },
  ANSWERED:     { bg: "#d1e7dd", color: "#0a3622" },
  RETURNED:     { bg: "#fff3cd", color: "#664d03" },
  IN_REVIEW:    { bg: "#fff3cd", color: "#664d03" },
  PENDING:      { bg: "#fff3cd", color: "#664d03" },
  ACTIVE:       { bg: "#d1e7dd", color: "#0a3622" },
  APPROVED:     { bg: "#d1e7dd", color: "#0a3622" },
  CLOSED:       { bg: "#198754", color: "#ffffff" },
  COMPLETE:     { bg: "#198754", color: "#ffffff" },
  RELEASED:     { bg: "#198754", color: "#ffffff" },
  REJECTED:     { bg: "#fde7e9", color: "#842029" },
  CANCELLED:    { bg: "#fde7e9", color: "#842029" },
  EXPIRED:      { bg: "#fde7e9", color: "#842029" },
  HOLD:         { bg: "#fde7e9", color: "#842029" },
};

// Page background color for paper-form pages.
export const PAGE_BG = "#fafafa";

// Inline-text utilities for sub-label hints.
export const FIELD_HINT = {
  color: "text.disabled",
  textTransform: "none",
  letterSpacing: 0,
  fontWeight: 400,
  fontSize: 11,
  ml: 0.5,
};

// Title-cases an enum status ("IN_PROGRESS" -> "In Progress") for display.
// Color lookups still key on the raw status, so callers pass the raw value
// and only the visible label is prettified.
export const prettyStatus = (v) =>
  !v ? v : String(v).split(/[_\s]+/).map((w) => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w)).join(" ");
